import { useState, useEffect } from 'react';
import { fetchUserInfo } from 'shared/security/KeycloakWrapperProvider';
import { fetchUser, fetchToken, fetchUserByRole } from 'shared/services/Api';
import { getCurrentUserRole } from 'shared/utils/SessionDataUtils';

const useInitializeUserData = (keycloak) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const init = async () => {
            try {
                await Promise.all([
                    fetchUserInfo(keycloak),

                    fetchUser(),
                    fetchToken(),
                ]);
                await fetchUserByRole(getCurrentUserRole())

                setReady(true);
            } catch (err) {
                console.error("❌ Initialization failed:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        if (keycloak?.authenticated) {
            init();
        } else {
            setLoading(false); // Not authenticated, skip initialization
        }
    }, [keycloak?.authenticated]);

    return { loading, error, ready };
};

export default useInitializeUserData;
